import { Routes, Route, Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import Import from "../Component/Dashboard/Import/Import";
import ModelConfiguration from "../Component/Dashboard/Default/TabLots/ModelConfiguration";
import DynamicModelRouter from "./DynamicModelRouter";
import ModelsVideoCodage from "../Component/Dashboard/Default/VideoCodage/ModelsVideoCodage";
import UploadDoc from "../Component/Dashboard/Default/UploadDoc/UploadDoc";
import DemoInvoice from "../Component/Dashboard/CompletedImport/CompletedImport";

export default function RouterUser() {
  const token = Cookies.get("Token");
  const role = Cookies.get("Role");

  if (!token || role !== "user") {
    localStorage.clear();
    Object.keys(Cookies.get()).forEach(function (cookieName) {
      Cookies.remove(cookieName);
    });
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <Routes>
        <Route index element={<ModelConfiguration />} />

        <Route path=":configKey" element={<DynamicModelRouter />} />

        <Route path="Import" element={<Import />} />
        <Route path="ModelsVideoCodage" element={<ModelsVideoCodage />} />
        <Route path="UploadDoc" element={<UploadDoc />} />
        <Route path="/DemoInvoice" element={<DemoInvoice />} />

        <Route path="*" element={<Navigate to="/User" replace />} />
      </Routes>
    </>
  );
}